class Status {
  checkList = [
    { label: 'open', value: 'open' },
    { label: 'closed', value: 'closed' }
  ]
}

export default new Status()
